'use client';

import React from 'react';
import classNames from 'classnames';

const IconsGroup = (props: {
  children: React.ReactNode;
  isHidden: boolean;
}) => {
  const { children, isHidden } = props;

  return (
    <div
      className={classNames('flex items-center gap-4 md:gap-8', {
        hidden: isHidden,
      })}
    >
      {children}
    </div>
  );
};

export default IconsGroup;
